// ==========================================================================
// PARSING / FORMATAGE PARTAGÉS DES CAS PRATIQUES
// Extrait de PariteFusion.jsx (lot 0 du module Mali) pour être partagé entre
// les services "cas pratiques" (Parité de fusion, Mali technique…) sans
// duplication. Fonctions pures, aucune dépendance React.
// ==========================================================================

// Saisie monétaire souple : "120M", "1,5M", "850k", "2Md", "120 000 000", "150,50".
export const parseMoney = (s) => {
  if (typeof s === "number") return isFinite(s) ? s : null;
  if (s == null) return null;
  let str = String(s).trim().toLowerCase().replace(/€/g, "").replace(/\s/g, "").replace(/,/g, ".");
  if (!str) return null;
  let mult = 1;
  if (str.endsWith("md")) { mult = 1e9; str = str.slice(0, -2); }
  else if (str.endsWith("b")) { mult = 1e9; str = str.slice(0, -1); }
  else if (str.endsWith("m")) { mult = 1e6; str = str.slice(0, -1); }
  else if (str.endsWith("k")) { mult = 1e3; str = str.slice(0, -1); }
  const n = parseFloat(str);
  return isFinite(n) ? n * mult : null;
};
export const locOf = (lang) => (lang === "fr" ? "fr-FR" : "en-US");
export const fmtDec = (v, loc, d = 3) =>
  v == null || !isFinite(v) ? "—" : v.toLocaleString(loc, { minimumFractionDigits: d, maximumFractionDigits: d });
export const fmtInt = (v, loc) => (v == null || !isFinite(v) ? "—" : Math.round(v).toLocaleString(loc));
export const fmtEuro = (v, loc) =>
  v == null || !isFinite(v) ? "—" : v.toLocaleString(loc, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
export const fmtMoney = (v, loc) => {
  if (v == null || !isFinite(v)) return "—";
  const a = Math.abs(v);
  if (a >= 1e9) return (v / 1e9).toLocaleString(loc, { maximumFractionDigits: 2 }) + " Md€";
  if (a >= 1e6) return (v / 1e6).toLocaleString(loc, { maximumFractionDigits: 2 }) + " M€";
  if (a >= 1e4) return (v / 1e3).toLocaleString(loc, { maximumFractionDigits: 1 }) + " k€";
  return fmtEuro(v, loc);
};
export const fmtPct = (v, loc) =>
  v == null || !isFinite(v)
    ? "—"
    : (v > 0 ? "+" : "") + (v * 100).toLocaleString(loc, { maximumFractionDigits: 1 }) + " %";
